module.exports = __webpack_public_path__ + "static/media/Gilroy-Bold.b59f283e.eot";